import React from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Link, useNavigate } from 'react-router-dom';

import routes from 'Lib/Routes/Routes';
import { resetToken } from 'Lib/HelperFunction/resetToken';
import { config } from 'config';

export default function HeaderComponent() {
  const navigate = useNavigate();
  function logout() {
    resetToken();
    navigate(routes.login.path, { replace: true });
  }
  return (
    <div >
      <AppBar position='static'>
        <Toolbar className='bg-black justify-between' >
          <Link to={routes.compilationList.path}>
            <Typography variant='h6'>Snappy</Typography>
          </Link>
          {localStorage.getItem(config.storage.token) && <div onClick={() => logout()} className='bg-red-700 px-3 py-1 rounded capitalize hover:bg-red-400 text-sm tracking-wider font-normal cursor-pointer'><LogoutOutlinedIcon /></div>}
        </Toolbar>
      </AppBar>
    </div>
  );
}
